import {sleep} from './sleep.js';

/* MediaDevices manipulation */

export default class StreamRecorder {

  constructor(stream){
    // this.stream = stream.clone();
    this.stream = stream;

    this.chunks = [];
    this.exportBlob = null;

    this.recording = false;
    this.initialized = false;
    this.recorder = null;

    this._init = this._init.bind(this);
    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this.getBlob = this.getBlob.bind(this);
    this.exportFile = this.exportFile.bind(this);
    this.clearStream = this.clearStream.bind(this);

    this._init();

  }

  _init() {

    const vtracks = this.stream.getVideoTracks().length;
    const atracks = this.stream.getAudioTracks().length;

      console.log('record');
    this.stream.getTracks().forEach(track => {
      console.log(track);
    });

    let mimeType = '';
    if (vtracks && atracks) mimeType = 'video/webm;codecs=vp8,opus';
    else if (vtracks && atracks === 0) mimeType = 'video/webm;codecs=vp8';
    else if (vtracks === 0 && atracks) mimeType = 'audio/opus;codecs=opus';
    else {console.error('No tracks to record');}

    const options = {
      mimeType: mimeType,
      audioBitsPersecond: 510000
//      videoBitsPerSecond: 128000,
    };

    try {
      this.recorder = new MediaRecorder(this.stream, options);
      this.initialized = true;
    } catch (e) {
      let noMimeTypeOptions = options;
      delete options.mimeType;
      this.recorder = new MediaRecorder(this.stream, noMimeTypeOptions);
      this.initialized = true;
    }

    this.recorder.onstop = async (e) => { 
      console.log('onstop');
      this.exportBlob 
        = await new Blob(this.chunks, {type: this.chunks[0].type});
    }

    this.recorder.ondataavailable = (e) =>  {
      console.log('ondataavailable');
      this.chunks.push(e.data); 
    };

  }

  start() {
    if (!this.initialized) return false;
    if (this.recording) return false;

    console.log('recording start', this.stream.getTracks());
    this.recorder.start(); 
    this.recording = true;
    return true;
  }

  async stop() { 
    if (!this.recording) return null;

    console.log('stop');
    await this.recorder.stop(); 
    console.log('stop complete');

    while (this.exportBlob === null) await sleep(1000);

    this.recording = false;
    return this.exportBlob;
  } 

  pause() {
    if (this.recorder.state === 'inactive') return false;
    this.recorder.pause();
    return true;
  }

  resume() {
    if (this.recorder.state !== 'inactive') return false;
    this.recorder.resume();
  }

  async getBlob() { 
     if (this.recording) await this.stop();
     return this.exportBlob; 
  }

  clearStream() {
    if (this.recording) return false;

    this.stream.getTracks().forEach (track => {
          this.stream.removeTrack(track);}); 

    return true; 
  }

  async exportFile(name){

    const type = this.exportBlob.type; 
    const tmp = type.split(';')[0];
    const extension = tmp.split('/')[1];

    const filename = `${Date.now()}_${name}.` + extension;
    // console.log(filename);

    try {
      const saveLink = document.createElement("a");
      saveLink.href = URL.createObjectURL(this.exportBlob);
      saveLink.download = filename;
      document.body.appendChild(saveLink);
      saveLink.click();
      document.body.removeChild(saveLink);
      return true;
    } catch(err) {
      console.error(err);
      return false;
    }
    
  }

};
